import apiClient from "./apiClient";

export const listManagementResourceRequest = (resource, data) => {
  const { nextPage = 1, ...body } = data || {};

  return apiClient({
    method: "POST",
    url: `/management/${resource}?page=${nextPage}`,
    data: body,
  });
};

export const getManagementResourceStatsRequest = (resource, data) =>
  apiClient({
    method: "POST",
    url: `/management/${resource}/stats`,
    data,
  });

export const createManagementResourceRequest = (resource, data) =>
  apiClient({
    method: "POST",
    url: `/management/${resource}/create`,
    data,
  });

export const updateManagementResourceRequest = (resource, id, data) =>
  apiClient({
    method: "PUT",
    url: `/management/${resource}/${id}`,
    data,
  });

export const deleteManagementResourceRequest = (resource, id) =>
  apiClient({
    method: "DELETE",
    url: `/management/${resource}/${id}`,
  });

export const getCryptoUsdRateRequest = () =>
  apiClient({
    method: "GET",
    url: "/crypto/rate",
  });

export const updateCryptoUsdRateRequest = (data) =>
  apiClient({
    method: "PUT",
    url: "/crypto/rate",
    data,
  });
